import React from "react";

import LocationOnIcon from "@mui/icons-material/LocationOn";
import EmailIcon from "@mui/icons-material/Email";
import PhoneIcon from "@mui/icons-material/Phone";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import InstagramIcon from "@mui/icons-material/Instagram";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import YouTubeIcon from "@mui/icons-material/YouTube";

import {
  appStoreButton,
  googlePlayButton,
  // kominfoLogo,
  ojkLogo,
  ojkHPSLogo,
} from "../assets";

export const navbarData_id = [
  { label: "Beranda", route: "/home" },
  { label: "Tentang Kami", route: "/about-us" },
  { label: "Produk", route: "/#products" },
  { label: "Hubungi Kami", route: "/#contact-us" },
  { label: "Insight", route: "/insight" },
];

export const navbarData_en = [
  { label: "Home", route: "/home" },
  { label: "About Us", route: "/about-us" },
  { label: "Products", route: "/#products" },
  { label: "Contact Us", route: "/#contact-us" },
  { label: "Insight", route: "/insight" },
];

export const HpamFooterData = [
  {
    title: "All investing involves risk.",
    contentsType: "disclaimer",
    contents: [
      {
        text: `Before investing you should carefully consider the Fund’s investment objectives, risks, charges and expenses. This fund may also allocate a portion of the portfolio to high risk assets which have high risk and return profile. This and other information are available through request for prospectus or at our company’s website. The fund is subject to market risks (volatility) and may not be appropriate for short term investments. Holdings and Sector weightings are subject to constant changes without notice as deemed fit by the investment management team. This document is for sophisticated investor only and not intended for individual private investor. Performance data quoted represent past performance and is no guarantee of future results. Investment returns and principal values may fluctuate so that an investor’s shares, when redeemed, may be worth more or less than their original cost. Current performance may be lower or higher than that shown. All return assume reinvestment of all dividend and capital gain distributions. Index performance is shown for illustrative purpose only. Conventional Non-bank institutions are prohibited from investing directly in index.`,
      },
    ],
  },
  {
    title: "PT Henan Putihrai Asset Management",
    contents: [
      {
        icon: <LocationOnIcon style={{ color: "white", fontSize: "24px" }} />,
        text: `Sahid Sudirman Center, 46th Floor \nJl. Jend Sudirman No. 86, Jakarta`,
        url: "https://goo.gl/maps/f9sJQuxYMe95q4oh6",
      },
      {
        icon: <EmailIcon style={{ color: "white", fontSize: "24px" }} />,
        text: "cs@hps.co.id",
        url: "mailto:cs@hpam.co.id",
      },
    ],
  },
  {
    title: "Bantuan",
    contents: [
      { text: "FAQ", url: "https://faq.myhero.id" },
      {
        text: "Hubungi Kami",
        url: "https://api.whatsapp.com/send/?phone=6287882525775",
      },
      { text: "Syarat & Ketentuan", url: "" },
      { text: "Kebijakan Privasi", url: "" },
    ],
  },
  {
    title: "Ikuti Kami",
    contentsType: "icon",
    contents: [
      {
        icon: <InstagramIcon style={{ color: "white", fontSize: "24px" }} />,
        url: "https://www.instagram.com/hpassetmanagement/",
      },
      {
        icon: <LinkedInIcon style={{ color: "white", fontSize: "24px" }} />,
        url: "https://www.linkedin.com/company/hpfinancials/",
      },
      {
        icon: <YouTubeIcon style={{ color: "white", fontSize: "24px" }} />,
        url: "https://www.youtube.com/channel/UCISGbJbqTPVdN9wxPLWhFKg",
      },
    ],
  },
  {
    // title: "Download Aplikasi",
    contentsType: "image",
    contents: [
      // {
      //   url: "https://play.google.com/store/apps/details?id=com.hpam.myhero",
      //   imgUrl: googlePlayButton,
      // },
      // {
      //   url: "https://apps.apple.com/id/app/myhero-hpam/id1499297292",
      //   imgUrl: appStoreButton,
      // },
      {
        url: "https://reksadana.ojk.go.id/Public/ManajerInvestasiPublic.aspx?id=HP002",
        imgUrl: ojkLogo,
        text: "KEP-04/BL/MI/2006",
      },
      // {
      //   url: "https://pse.dev.kominfo.go.id/sistem/1259",
      //   imgUrl: kominfoLogo,
      //   text: "00843/DJAI.PSE/04/2018",
      // },
    ],
  },
];

export const HpsFooterData = [
  {
    title: "All investing involves risk.",
    contentsType: "disclaimer",
    contents: [
      {
        text: `Before investing you should carefully consider the Fund’s investment objectives, risks, charges and expenses. This fund may also allocate a portion of the portfolio to high risk assets which have high risk and return profile. This and other information are available through request for prospectus or at our company’s website. The fund is subject to market risks (volatility) and may not be appropriate for short term investments. Holdings and Sector weightings are subject to constant changes without notice as deemed fit by the investment management team. This document is for sophisticated investor only and not intended for individual private investor. Performance data quoted represent past performance and is no guarantee of future results. Investment returns and principal values may fluctuate so that an investor’s shares, when redeemed, may be worth more or less than their original cost. Current performance may be lower or higher than that shown. All return assume reinvestment of all dividend and capital gain distributions. Index performance is shown for illustrative purpose only. Conventional Non-bank institutions are prohibited from investing directly in index.`,
      },
    ],
  },
  {
    title: "PT Henan Putihrai Sekuritas",
    contents: [
      {
        icon: <LocationOnIcon style={{ color: "white", fontSize: "24px" }} />,
        text: `Sahid Sudirman Center, 46th Floor \nJl. Jend Sudirman No. 86, Jakarta`,
        url: "https://goo.gl/maps/f9sJQuxYMe95q4oh6",
      },
      {
        icon: <PhoneIcon style={{ color: "white", fontSize: "24px" }} />,
        text: "+62139702888",
        url: "tel:+62139702888",
      },
      {
        icon: <WhatsAppIcon style={{ color: "white", fontSize: "24px" }} />,
        text: "+62 888-2525-888",
        url: "https://api.whatsapp.com/send/?phone=628882525888",
      },
      {
        icon: <EmailIcon style={{ color: "white", fontSize: "24px" }} />,
        text: "cs@henanputihrai.com",
        url: "mailto:cs@henanputihrai.com",
      },
    ],
  },
  {
    title: "Ikuti Kami",
    contentsType: "icon",
    contents: [
      {
        icon: <InstagramIcon style={{ color: "white", fontSize: "24px" }} />,
        url: "https://www.instagram.com/hpsekuritas/",
      },
      {
        icon: <LinkedInIcon style={{ color: "white", fontSize: "24px" }} />,
        url: "https://www.linkedin.com/company/henanputihraisekuritas/",
      },
      // {
      // 	icon: <YouTubeIcon style={{ color: "white", fontSize: "24px" }} />,
      // 	url: "https://www.youtube.com/channel/UCISGbJbqTPVdN9wxPLWhFKg",
      // },
    ],
  },
  {
    title: "Berizin & Diawasi",
    contentsType: "image",
    contents: [
      {
        url: "https://pasarmodal.ojk.go.id/PerusahaanEfek/Detail/HP",
        imgUrl: ojkHPSLogo,
      },
      { text: "Kebijakan Privasi", url: "" },
    ],
  },
  {
    title: "Download Aplikasi",
    contentsType: "image",
    contents: [
      {
        url: "https://play.google.com/store/apps/details?id=com.henanputihrai.nextgen",
        imgUrl: googlePlayButton,
      },
      {
        url: "https://apps.apple.com/vn/app/hpx-next-gen/id6443839263",
        imgUrl: appStoreButton,
      },
    ],
  },
];

export const productDataTestID = [
  {
    productCode: "equitybrokerage",
    title: "Equity Brokerage",
    description:
      "Divisi Equity Brokerage menyediakan layanan perantara efek yang komprehensif, mencakup transaksi reguler serta fasilitas pembiayaan margin. Didukung oleh tim Equity Sales yang berpengalaman, setiap transaksi dijalankan secara efisien dan andal.",
    contents: [
      {
        title: "Fasilitas Margin",
        description:
          "Memungkinkan pembelian efek dengan dukungan pembiayaan, sesuai dengan kriteria yang berlaku. Akun margin memberikan fleksibilitas periode kepemilikan tanpa mekanisme forced sell dalam kondisi pasar normal.",
      },
      {
        title: "Fasilitas REPO",
        description:
          "Menyediakan pembiayaan melalui skema repurchase agreement bagi nasabah yang memenuhi persyaratan. Sejalan dengan fasilitas margin, skema ini memberikan fleksibilitas periode kepemilikan tanpa likuidasi paksa dalam kondisi normal.",
      },
    ],
  },
  {
    productCode: "fixedincome",
    title: "Fixed Income",
    description:
      "Di Divisi Pendapatan Tetap, kami menghadirkan pilihan layanan menarik untuk transaksi surat hutang. Kami memfasilitasi transaksi jual beli produk Fixed Income baik di pasar primer maupun sekunder dalam mata uang Rupiah dan USD. Komitmen kami juga mencakup kerja sama dengan dealer utama lainnya untuk melayani transaksi lelang obligasi pemerintah. Kami melayani berbagai macam nasabah, termasuk lembaga keuangan seperti perusahaan asuransi, manajer investasi, dana pensiun, bank, dan perusahaan sekuritas lainnya. Seiring waktu, kami telah memperluas layanan kami untuk mencakup pelanggan ritel, memastikan inklusivitas dan aksesibilitas.",
  },
  {
    productCode: "investmentbanking",
    title: "Investment Banking",
    description:
      "Divisi Investment Banking menyediakan layanan pembiayaan dan advisory yang komprehensif, didukung oleh pengalaman mendalam serta akses pasar yang luas di berbagai transaksi pasar modal.",
    contents: [
      {
        title: "Advisory dan Discretionary Mandates",
        description:
          "Memberikan advisory strategis terkait pembiayaan dan restrukturisasi korporasi, dengan dukungan analisis pasar untuk mengoptimalkan strategi keuangan.",
      },
      {
        title: "Underwriting dan Penerbitan Efek",
        description:
          "Berperan sebagai penjamin emisi dan penasihat keuangan dalam transaksi pasar modal, termasuk IPO, rights issue, dan penerbitan obligasi, dengan eksekusi yang terstruktur dan efisien.",
      },
      {
        title: "Structured Finance",
        description:
          "Menyediakan solusi pembiayaan terstruktur melalui instrumen seperti sekuritisasi aset, termasuk CDO dan ABS, untuk memenuhi kebutuhan pendanaan yang lebih kompleks.",
      },
    ],
  },
  {
    productCode: "research-and-analysis",
    title: "Research and Analysis",
    description:
      "Di Departemen Riset dan Analisis Ekuitas, kami terdorong untuk memberikan alfa bagi klien ritel dan institusional kami yang berharga. Tim analis berpengalaman kami, yang ditampilkan dalam berbagai publikasi, memberikan ide penelitian yang tepat waktu dan berwawasan luas di semua sektor industri. Dengan menawarkan pembaruan industri yang berkelanjutan di berbagai sektor, kami memastikan aliran informasi berharga yang konsisten. Pola pikir kolektif para analis kami, dikombinasikan dengan pengalaman mereka yang luas, menambah konteks dan kredibilitas opini kami, sehingga membedakan kami dari pesaing.",
  },
];

export const productDataTestEN = [
  {
    productCode: "equitybrokerage",
    title: "Equity Brokerage",
    description:
      "The Equity Brokerage Division provides comprehensive securities brokerage services, covering both regular transactions and margin financing. Supported by an experienced Equity Sales team, transactions are executed with efficiency and reliability.",
    contents: [
      {
        title: "Margin Facility",
        description:
          "Provision of financing which enables clients to purchase securities, subject to eligibility criteria. Margin accounts offer extended holding flexibility without forced selling under normal market conditions.",
      },
      {
        title: "REPO Facility",
        description:
          "Provides financing through repurchase agreements for eligible clients. Similar to margin facilities, repo arrangements offer extended holding periods without forced liquidation under standard conditions.",
      },
    ],
  },
  {
    productCode: "fixedincome",
    title: "Fixed Income",
    description:
      "In our Fixed Income Division, we present attractive service options for debenture transactions. We facilitate buying and selling transactions of Fixed Income products in both the primary and secondary markets, denominated in Rupiah and USD. Our commitment extends to collaborating with other primary dealers to serve government bond auction transactions. We cater to a wide range of customers, including financial institutions such as insurance companies, investment managers, pension funds, banks, and other securities companies. Over time, we have expanded our services to include retail customers, ensuring inclusivity and accessibility.",
  },
  {
    productCode: "investmentbanking",
    title: "Investment Banking",
    description:
      "The Investment Banking Division provides a broad range of funding and advisory services, leveraging extensive experience and market access across capital market transactions.",
    contents: [
      {
        title: "Advisory and Discretionary Mandates",
        description:
          "Provides strategic advisory on corporate financing and restructuring, supported by in-depth market insights to optimize financial strategies.",
      },
      {
        title: "IPO Underwriting and Issuance",
        description:
          "Acts as underwriter and financial advisor in equity and debt capital market transactions, including IPOs, rights issues, and bond offerings, ensuring efficient and well-structured execution.",
      },
      {
        title: "Structured Finance",
        description:
          "Delivers tailored financing solutions through structured instruments, including asset securitization such as CDOs and ABS, to support complex funding requirements.",
      },
    ],
  },
  {
    productCode: "research-and-analysis",
    title: "Research and Analysis",
    description:
      "At our Equity Research and Analytics Department, we are driven to deliver alpha for our valued retail and institutional clients. Our team of experienced analysts, featured in numerous publications, provides timely and insightful research ideas across all industry sectors. By offering ongoing industry updates across multiple verticals, we ensure a consistent flow of valuable information. The collective mindshare of our analysts, combined with their extensive experience, adds context and credibility to our opinions, setting us apart from the competition.",
  },
];
